import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Plus, X } from "lucide-react";

export default function ListEditor({ label, items = [], onChange, placeholder = "Add item…" }) {
  const update = (i, v) => onChange(items.map((x, k) => (k === i ? v : x)));
  return (
    <div className="grid gap-2">
      {label && <div className="text-sm font-medium">{label}</div>}
      {items.map((item, i) => (
        <div key={i} className="flex gap-2">
          <Input value={item} onChange={(e) => update(i, e.target.value)} placeholder={placeholder} data-testid={`list-item-${i}`} />
          <Button type="button" variant="ghost" size="icon" onClick={() => onChange(items.filter((_, k) => k !== i))} data-testid={`list-remove-${i}`}>
            <X className="h-4 w-4" />
          </Button>
        </div>
      ))}
      <Button type="button" variant="outline" size="sm" className="justify-start w-fit" onClick={() => onChange([...items, ""])} data-testid="list-add-btn">
        <Plus className="h-3.5 w-3.5 mr-1.5" /> Add
      </Button>
    </div>
  );
}
